import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c1edb8d")

_pushScopeId("data-v-1c1edb8d")
const _hoisted_1 = { class: "row-overlay" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_list_row_item_text = _resolveComponent("list-row-item-text")
  const _component_list_row_item_text_multiline = _resolveComponent("list-row-item-text-multiline")
  const _component_list_row_item_text_multiline_link = _resolveComponent("list-row-item-text-multiline-link")
  const _component_list_row_item_emphasized_text = _resolveComponent("list-row-item-emphasized-text")
  const _component_list_row_item_emphasized_text_multiline = _resolveComponent("list-row-item-emphasized-text-multiline")
  const _component_list_row_item_permission = _resolveComponent("list-row-item-permission")
  const _component_list_row_item_button = _resolveComponent("list-row-item-button")
  const _component_list_row_item_multi_button = _resolveComponent("list-row-item-multi-button")
  const _component_list_row_item_multi_icon_button = _resolveComponent("list-row-item-multi-icon-button")
  const _component_list_row_item_select_box = _resolveComponent("list-row-item-select-box")
  const _component_list_row_item_edit_box = _resolveComponent("list-row-item-edit-box")
  const _component_list_row_item_circle_marks = _resolveComponent("list-row-item-circle-marks")
  const _component_list_row_item_kartes = _resolveComponent("list-row-item-kartes")
  const _component_list_row_item_bookmark = _resolveComponent("list-row-item-bookmark")
  const _component_list_row_item_checkbox = _resolveComponent("list-row-item-checkbox")

  return (_openBlock(), _createBlock("div", {
    class: ["row", [_ctx.$mq, _ctx.selected ? 'selected' : '']],
    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('row')))
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
      return (_openBlock(), _createBlock(_Fragment, null, [
        (column.type === 'text')
          ? (_openBlock(), _createBlock(_component_list_row_item_text, {
              key: 'column-'+_ctx.rowId+'-'+index,
              style: _ctx.styles[index],
              value: column.value
            }, null, 8, ["style", "value"]))
          : _createCommentVNode("", true),
        (column.type === 'textMultiline')
          ? (_openBlock(), _createBlock(_component_list_row_item_text_multiline, {
              key: 'column-'+_ctx.rowId+'-'+index,
              style: _ctx.styles[index],
              values: column.values,
              columnId: _ctx.rowId+'-'+index,
              onClick: ($event: any) => (column.emitType && _ctx.$emit(column.emitType))
            }, null, 8, ["style", "values", "columnId", "onClick"]))
          : _createCommentVNode("", true),
        (column.type === 'textMultilineLink')
          ? (_openBlock(), _createBlock(_component_list_row_item_text_multiline_link, {
              key: 'column-'+_ctx.rowId+'-'+index,
              style: _ctx.styles[index],
              values: column.values,
              columnId: _ctx.rowId+'-'+index
            }, null, 8, ["style", "values", "columnId"]))
          : _createCommentVNode("", true),
        (column.type === 'emphasizedText')
          ? (_openBlock(), _createBlock(_component_list_row_item_emphasized_text, {
              key: 'column-'+_ctx.rowId+'-'+index,
              style: _ctx.styles[index],
              value: column.value,
              searchWord: _ctx.searchWord
            }, null, 8, ["style", "value", "searchWord"]))
          : _createCommentVNode("", true),
        (column.type === 'emphasizedTextMultiline')
          ? (_openBlock(), _createBlock(_component_list_row_item_emphasized_text_multiline, {
              key: 'column-'+_ctx.rowId+'-'+index,
              style: _ctx.styles[index],
              values: column.values,
              columnId: _ctx.rowId+'-'+index,
              searchWord: _ctx.searchWord
            }, null, 8, ["style", "values", "columnId", "searchWord"]))
          : _createCommentVNode("", true),
        (column.type === 'permission')
          ? (_openBlock(), _createBlock(_component_list_row_item_permission, {
              key: 'column-'+_ctx.rowId+'-'+index,
              style: _ctx.styles[index],
              permissions: column.value
            }, null, 8, ["style", "permissions"]))
          : (column.type === 'button')
            ? (_openBlock(), _createBlock(_component_list_row_item_button, {
                class: "row-item-button",
                key: 'column-'+_ctx.rowId+'-'+index,
                style: _ctx.styles[index],
                value: column.value,
                state: column.state,
                disabled: column.disabled || false,
                onClick: ($event: any) => (_ctx.$emit('click', { emitType: column.emitType, id: _ctx.rowId }))
              }, null, 8, ["style", "value", "state", "disabled", "onClick"]))
            : (column.type === 'buttons')
              ? (_openBlock(), _createBlock(_component_list_row_item_multi_button, {
                  class: "row-item-button",
                  key: 'column-'+_ctx.rowId+'-'+index,
                  style: _ctx.styles[index],
                  buttons: column.buttons,
                  columnId: _ctx.rowId+'-'+index,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click', { emitType: $event, id: _ctx.rowId })))
                }, null, 8, ["style", "buttons", "columnId"]))
              : (column.type === 'iconButtons')
                ? (_openBlock(), _createBlock(_component_list_row_item_multi_icon_button, {
                    class: "row-item-button",
                    key: 'column-'+_ctx.rowId+'-'+index,
                    style: _ctx.styles[index],
                    buttons: column.buttons,
                    columnId: _ctx.rowId+'-'+index,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('click', { emitType: $event, id: _ctx.rowId })))
                  }, null, 8, ["style", "buttons", "columnId"]))
                : (column.type === 'select')
                  ? (_openBlock(), _createBlock(_component_list_row_item_select_box, {
                      key: 'column-'+_ctx.rowId+'-'+index,
                      style: _ctx.styles[index],
                      items: column.items,
                      selected: column.selected,
                      disabled: column.disabled,
                      "onUpdate:modelValue": ($event: any) => (_ctx.$emit(column.emitType, $event))
                    }, null, 8, ["style", "items", "selected", "disabled", "onUpdate:modelValue"]))
                  : (column.type === 'edit')
                    ? (_openBlock(), _createBlock(_component_list_row_item_edit_box, {
                        key: 'column-'+_ctx.rowId+'-'+index,
                        style: _ctx.styles[index],
                        readonly: column.readonly || false,
                        value: column.value,
                        "onUpdate:modelValue": ($event: any) => (_ctx.$emit(column.emitType, $event))
                      }, null, 8, ["style", "readonly", "value", "onUpdate:modelValue"]))
                    : (column.type === 'circleMarks')
                      ? (_openBlock(), _createBlock(_component_list_row_item_circle_marks, {
                          key: 'column-'+_ctx.rowId+'-'+index,
                          style: _ctx.styles[index],
                          marks: column.value,
                          columnId: _ctx.rowId+'-'+index
                        }, null, 8, ["style", "marks", "columnId"]))
                      : (column.type === 'kartes')
                        ? (_openBlock(), _createBlock(_component_list_row_item_kartes, {
                            key: 'column-'+_ctx.rowId+'-'+index,
                            style: _ctx.styles[index],
                            values: column.values,
                            columnId: _ctx.rowId+'-'+index,
                            onBookmark: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('bookmark', $event))),
                            onUp: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('up', $event))),
                            onDown: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('down', $event)))
                          }, null, 8, ["style", "values", "columnId"]))
                        : (column.type === 'bookmark')
                          ? (_openBlock(), _createBlock(_component_list_row_item_bookmark, {
                              key: 'column-'+_ctx.rowId+'-'+index,
                              style: _ctx.styles[index],
                              value: column.value,
                              columnId: _ctx.rowId+'-'+index,
                              onBookmark: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('bookmark', $event)))
                            }, null, 8, ["style", "value", "columnId"]))
                          : (column.type === 'checkbox')
                            ? (_openBlock(), _createBlock(_component_list_row_item_checkbox, {
                                key: 'column-'+_ctx.rowId+'-'+index,
                                style: _ctx.styles[index],
                                value: column.value,
                                "onUpdate:modelValue": ($event: any) => (_ctx.$emit(column.emitType, $event))
                              }, null, 8, ["style", "value", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true)
      ], 64))
    }), 256)),
    _createVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 2))
})